import { EConnectionType } from '../const';

const LOGIN_TYPE_STORAGE_KEY = '___connection_type';

/**
 * Save connection type to local storage.
 *
 * @param connectionType - type of login.
 * @returns void.
 */
export function storeConnectionType(
  connectionType: EConnectionType | null,
): void {
  if (!connectionType) {
    removeStoredConnectionType();

    return;
  }

  localStorage.setItem(LOGIN_TYPE_STORAGE_KEY, connectionType);
}

/**
 * Restore connection type from local storage.
 *
 * @returns connection type.
 */
export function restoreConnectionType(): EConnectionType | undefined {
  return localStorage.getItem(LOGIN_TYPE_STORAGE_KEY) as
    | EConnectionType
    | undefined;
}

/**
 * Remove connection type from local storage.
 *
 * @returns void.
 */
export function removeStoredConnectionType(): void {
  localStorage.removeItem(LOGIN_TYPE_STORAGE_KEY);
}
